// extracted by mini-css-extract-plugin
export default {"w75":"Footer_w75__EwR6x","fsbtn":"Footer_fsbtn__a9IEg","borderTop":"Footer_borderTop__2W7PT","fs8":"Footer_fs8__TOee1"};